// 配額模塊
export default {
    Quota: {
        Quota: '配額',
        AddQuotaOptions: '新增配額選項',
        Name: '名稱',
        deleteIt: '確定刪除嗎？',
        RuleType: '規則類型',
        DisplayQuota: '顯示配額',
        HideQuota: '隱藏配額',
        QuotaNumber: '配額數',
        CompleteNumber: '完成數',
        RuleName: '規則名稱',
        DisplayQuotaTip: '(在作答過程中檢查配額，配額已滿即不可選擇)',
        QuotaFullTip: '配額已滿提示文案',
        QuotaFullPlaceholder: '配額已滿(最多十個字)',
        HideQuotaTip: '(在提交答卷後檢查配額，配額已滿自動標記為無效答卷)',
        RuleCondition1: '規則條件1',
        PleaseSelect: '請選擇',
        AddConditions: '添加條件',
        RuleCondition2: '規則條件2',
        QuotaDetails: '配額詳情',
        NotSetTotalQuota: '(可留空，留空默認為不設置配額總數)',
        FillDown: '向下填充',
        QuotaQuantity: '配額數量',
        ModifyQuotaCount: '修改配額數',
        PleaseEnterModifyQuotaCount: '請輸入修改配額數值',
        AddQuotaRules: '新增配額規則',
        ModifyQuotaRules: '修改配額規則',
        PleaseEnterNumberQuotasModify: '請輸入要修改的配額數',
        SuccessfullyDeleted: '刪除成功'
    },
  };